import React from 'react';
import OrderPage from '../../OrderPage';
import OrderDetails from '../OrderDetails';
import { OrderTarget } from '../../../components/OrdersTable/interfaces/OrderStatus.interface';

const ProducerOrderPage: React.FC = () => (
	<OrderPage
		target={OrderTarget.producer}
		renderDetails={({ order, isOpen, onBack }) => (
			<OrderDetails
				key={order.id}
				isOpen={isOpen}
				selectedOrder={order}
				position="relative"
				onBack={onBack}
			/>
		)}
	/>
);

export default ProducerOrderPage;
